import { render, staticRenderFns } from "./AssistenteNorma.vue?vue&type=template&id=423fa4b8"
import script from "./AssistenteNorma.vue?vue&type=script&lang=js"
export * from "./AssistenteNorma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports